import { isClientRejection } from '@integrations/shared/retry-policy';

/**
 * "CRM is disabled for this account" is inferred from the contacts/attributes request:
 * an account without CRM gets a definitive client rejection (4xx) instead of attributes.
 *
 * A transient failure — offline, aborted request, timeout, 5xx, rate limit — must NOT be
 * read as "disabled". Treating every failure alike hid the whole CRM section (pipeline,
 * deal status, CRM tags, address book) after one flaky request while CRM was in fact
 * connected, and the panel stayed wrong until the settings were reloaded (#71534).
 *
 * When the request keeps failing transiently the section stays visible with empty
 * collections — a recoverable state — rather than claiming the feature is off.
 */
export function isCrmDisabledError(error: unknown): boolean {
    return isClientRejection(error);
}
